import React from "react";
import { Trans } from "@lingui/macro";
import SEO from "components/Common/SEO";

import Footer from "components/Footer/Footer";
import { getPageTitle } from "lib/legacy";

import arbitrumIcon from "img/ic_arbitrum_16.svg";
import avalancheIcon from "img/ic_avalanche_16.svg";

import "./Ecosystem.css";
import ExternalLink from "components/ExternalLink/ExternalLink";
import { ARBITRUM, AVALANCHE } from "config/chains";
import { t } from "@lingui/macro";
import PageNotFound from "pages/PageNotFound/PageNotFound";

const NETWORK_ICONS = {
  [ARBITRUM]: arbitrumIcon,
  [AVALANCHE]: avalancheIcon,
};

const NETWORK_ICON_ALTS = {
  [ARBITRUM]: "Arbitrum Icon",
  [AVALANCHE]: "Avalanche Icon",
};

export default function Ecosystem() {
  const gmxPages = [
    {
      title: "OPEN Governance",
      link: "https://gov.gmx.io/",
      linkLabel: "gov.gmx.io",
      about: t`OPEN Governance Page`,
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Stats",
      link: "http://api.openworld.vision:8080/",
      linkLabel: "stats.gmx.io",
      about: t`OPEN Stats Page`,
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Proposals",
      link: "https://snapshot.org/#/gmx.eth",
      linkLabel: "snapshot.org",
      about: t`OPEN Proposals Voting page`,
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Announcements",
      link: "https://t.me/GMX_Announcements",
      linkLabel: "t.me",
      about: t`OPEN Announcements and Updates`,
      chainIds: [ARBITRUM, AVALANCHE],
    },
  ];

  const communityProjects = [
    {
      title: "OPEN Blueberry Club",
      link: "https://www.blueberry.club/",
      linkLabel: "blueberry.club",
      about: t`OPEN Blueberry NFTs`,
      creatorLabel: "@xm92boi",
      creatorLink: "https://t.me/xm92boi",
      chainIds: [ARBITRUM],
    },
    {
      title: "OPEN Leaderboard",
      link: "https://www.gmx.house/",
      linkLabel: "gmx.house",
      about: t`Leaderboard for OPEN traders`,
      creatorLabel: "@Itburnz",
      creatorLink: "https://t.me/Itburnz",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Positions Bot",
      link: "https://t.me/GMXPositions",
      linkLabel: "t.me",
      about: t`Telegram bot for OPEN position updates`,
      creatorLabel: "@zhongfu",
      creatorLink: "https://t.me/zhongfu",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Blueberry Pulse",
      link: "https://blueberrypulse.substack.com/",
      linkLabel: "substack.com",
      about: t`OPEN Weekly Updates`,
      creatorLabel: "@puroscohiba",
      creatorLink: "https://t.me/puroscohiba",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "DegenClip",
      link: "https://degenclip.com/gmx",
      linkLabel: "degenclip.com",
      about: t`Community curated tweet collection`,
      creatorLabel: "@ox21l",
      creatorLink: "https://t.me/ox21l",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Yield Simulator",
      link: "https://gmx.defisims.com/",
      linkLabel: "defisims.com",
      about: t`Yield simulator for OPEN`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Returns Calculator",
      link: "https://docs.google.com/spreadsheets/u/4/d/1mQZlztz_NpTg5qQiYIzc_Ls1OTLfMOUtmEQN-WW8jj4/copy",
      linkLabel: "docs.google.com",
      about: t`Returns calculator for OPEN and OAP`,
      creatorLabel: "@AStoicTrader1",
      creatorLink: "https://twitter.com/AStoicTrader1",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Compound Calculator",
      link: "https://docs.google.com/spreadsheets/d/14DiIE1wZkK9-Y5xSx1PzIgmpcj4ccz1YVw5nwzIWLgI/edit#gid=0",
      linkLabel: "docs.google.com",
      about: t`Optimal compound interval calculator`,
      creatorLabel: "@ChasenKaminsky",
      creatorLink: "https://twitter.com/ChasenKaminsky",
      chainIds: [AVALANCHE],
    },
    {
      title: "OPEN Trading Stats",
      link: "https://t.me/GMXTradingStats",
      linkLabel: "t.me",
      about: t`Telegram bot for Open Interest on OPEN`,
      creatorLabel: "@SniperMonke01",
      creatorLink: "https://twitter.com/SniperMonke01",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Staking Bot",
      link: "https://t.me/GMX_Staking_bot",
      linkLabel: "t.me",
      about: t`OPEN staking rewards updates and insights`,
      creatorLabel: "@GMX_Staking_bot",
      creatorLink: "https://twitter.com/GMX_Staking_bot",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Staking Calculator",
      link: "https://gmxstaking.com",
      linkLabel: "gmxstaking.com",
      about: t`OPEN staking calculator`,
      creatorLabel: "@n1njawtf",
      creatorLink: "https://t.me/n1njawtf",
      chainIds: [ARBITRUM, AVALANCHE],
    },
  ];

  const dashboardProjects = [
    {
      title: "OPEN Referrals Dashboard",
      link: "https://www.gmxreferrals.com/",
      linkLabel: "gmxreferrals.com",
      about: t`Dashboard for OPEN referral stats`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "OPEN Terminal",
      link: "https://gmxterminal.com",
      linkLabel: "gmxterminal.com",
      about: t`OPEN explorer for stats and traders`,
      creatorLabel: "@vipineth",
      creatorLink: "https://t.me/vipineth",
      chainIds: [ARBITRUM],
    },
    {
      title: "OPEN Analytics",
      link: "https://gmxstats.com/",
      linkLabel: "gmxstats.com",
      about: t`Financial reports and protocol analytics`,
      creatorLabel: "@CryptoMessiah",
      creatorLink: "https://t.me/LarpCapital",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "TokenTerminal",
      link: "https://tokenterminal.com/terminal/projects/gmx",
      linkLabel: "tokenterminal.com",
      about: t`OPEN fundamentals`,
      creatorLabel: "@tokenterminal",
      creatorLink: "https://twitter.com/tokenterminal",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "CryptoFees",
      link: "https://cryptofees.info",
      linkLabel: "cryptofees.info",
      about: t`Fees generated by OPEN`,
      creatorLabel: "@CryptoFeesInfo",
      creatorLink: "https://twitter.com/CryptoFeesInfo",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Shogun Dashboard (Dune BSC)",
      link: "https://dune.com/shogun/gmx-analytics-arbitrum",
      linkLabel: "dune.com",
      about: t`Protocol analytics`,
      creatorLabel: "@JamesCliffyz",
      creatorLink: "https://twitter.com/JamesCliffyz",
      chainIds: [ARBITRUM],
    },
    {
      title: "Shogun Dashboard (Dune BSC)",
      link: "https://dune.com/shogun/gmx-analytics-avalanche",
      linkLabel: "dune.com",
      about: t`Protocol analytics`,
      creatorLabel: "@JamesCliffyz",
      creatorLink: "https://twitter.com/JamesCliffyz",
      chainIds: [AVALANCHE],
    },
    {
      title: "OPEN Perpetuals Data",
      link: "https://app.laevitas.ch/altsderivs/OPEN/perpetualswaps",
      linkLabel: "laevitas.ch",
      about: t`OPEN Perpetuals Data`,
      creatorLabel: "@laevitas1",
      creatorLink: "https://twitter.com/laevitas1",
      chainIds: [ARBITRUM],
    },
    {
      title: "OPEN Blueberry Leaderboard",
      link: "https://www.blueberryboard.com",
      linkLabel: "blueberryboard.com",
      about: t`GBC NFTs APR tracker and rewards`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM],
    },
  ];

  const integrations = [
    {
      title: "DeBank",
      link: "debank.com",
      linkLabe: "debank.com",
      about: t`DeFi Portfolio Tracker`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1439711532884152324",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Defi Llama",
      link: "https://defillama.com",
      linkLabel: "defillama.com",
      about: t`Decentralized Finance Dashboard`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1438124768033660938",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Dopex",
      link: "https://dopex.io",
      linkLabel: "dopex.io",
      about: t`Decentralized Options Protocol`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1482445801523716099",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Rook",
      link: "https://www.rook.fi/",
      linkLabel: "rook.fi",
      about: t`MEV Optimizer`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/Rook/status/1509613786600116251",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Jones DAO",
      link: "https://jonesdao.io",
      linkLabel: "jonesdao.io",
      about: t`Decentralized Options Strategies`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1482788805635678212",
      chainIds: [ARBITRUM],
    },
    {
      title: "Yield Yak Optimizer",
      link: "https://yieldyak.com/",
      linkLabel: "yieldyak.com",
      about: t`Yield Optimizer on BSC`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1484601407378378754",
      chainIds: [AVALANCHE],
    },
    {
      title: "Vovo Finance",
      link: "https://vovo.finance/",
      linkLabel: "vovo.finance",
      about: t`Structured Products`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/VovoFinance/status/1531517177790345217",
      chainIds: [ARBITRUM],
    },
    {
      title: "Stabilize Protocol",
      link: "https://www.stabilize.finance/",
      linkLabel: "stabilize.finance",
      about: t`Yield Vaults`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/StabilizePro/status/1532348674986082306",
      chainIds: [ARBITRUM],
    },
    {
      title: "DODO",
      link: "https://dodoex.io/",
      linkLabel: "dodoex.io",
      about: t`Decentralized Trading Protocol`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1438899138549145605",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Open Ocean",
      link: "https://openocean.finance/",
      linkLabel: "openocean.finance",
      about: t`DEX Aggregator`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1495780826016989191",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Paraswap",
      link: "https://www.paraswap.io/",
      linkLabel: "paraswap.io",
      about: t`DEX Aggregator`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/paraswap/status/1546869879336222728",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "1inch",
      link: "https://1inch.io/",
      linkLabel: "1inch.io",
      about: t`DEX Aggregator`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/OpenWorldVision/status/1522247451410845696",
      chainIds: [ARBITRUM, AVALANCHE],
    },
    {
      title: "Firebird Finance",
      link: "https://app.firebird.finance/swap",
      linkLabel: "firebird.finance",
      about: t`DEX Aggregator`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/financefirebird/status/1561767094064238595",
      chainIds: [AVALANCHE],
    },
    {
      title: "Yield Yak Swap",
      link: "https://yieldyak.com/swap",
      linkLabel: "yieldyak.com",
      about: t`DEX Aggregator`,
      announcementLabel: "twitter.com",
      announcementLink: "https://twitter.com/yieldyak_/status/1484458884827947008",
      chainIds: [AVALANCHE],
    },
  ];

  const telegramGroups = [
    {
      title: "OPEN",
      link: "https://t.me/CryptoWarVietnamesegames",
      linkLabel: "t.me",
      about: t`Telegram Group`,
    },
    {
      title: "OPEN (Chinese)",
      link: "https://t.me/gmxch",
      linkLabel: "t.me",
      about: t`Telegram Group (Chinese)`,
    },
    {
      title: "OPEN (Portuguese)",
      link: "https://t.me/GMX_Portuguese",
      linkLabel: "t.me",
      about: t`Telegram Group (Portuguese)`,
    },
    {
      title: "OPEN Trading Chat",
      link: "https://t.me/gambittradingchat",
      linkLabel: "t.me",
      about: t`OPEN community discussion`,
    },
  ];
  return <PageNotFound />;
  // return (
  //   <SEO title={getPageTitle("Ecosystem Projects")}>
  //     <div className="default-container page-layout">
  //       <div>
  //         <div className="section-title-block">
  //           <div className="section-title-icon" />
  //           <div className="section-title-content">
  //             <div className="Page-title">
  //               <Trans>OPEN Pages</Trans>
  //             </div>
  //             <div className="Page-description">
  //               <Trans>OPEN ecosystem pages.</Trans>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="DashboardV2-projects">
  //           {gmxPages.map((item) => {
  //             const linkLabel = item.linkLabel ? item.linkLabel : item.link;
  //             return (
  //               <div className="App-card" key={item.title}>
  //                 <div className="App-card-title">
  //                   {item.title}
  //                   <div className="App-card-title-icon">
  //                     {item.chainIds.map((network) => (
  //                       <img key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
  //                     ))}
  //                   </div>
  //                 </div>
  //                 <div className="App-card-divider"></div>
  //                 <div className="App-card-content">
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Link</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>About</Trans>
  //                     </div>
  //                     <div>{item.about}</div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //         <div className="Tab-title-section">
  //           <div className="Page-title">
  //             <Trans>Community Projects</Trans>
  //           </div>
  //           <div className="Page-description">
  //             <Trans>Projects developed by the OPEN community.</Trans>
  //           </div>
  //         </div>
  //         <div className="DashboardV2-projects">
  //           {communityProjects.map((item) => {
  //             const linkLabel = item.linkLabel ? item.linkLabel : item.link;
  //             return (
  //               <div className="App-card" key={item.title}>
  //                 <div className="App-card-title">
  //                   {item.title}
  //                   <div className="App-card-title-icon">
  //                     {item.chainIds.map((network) => (
  //                       <img key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
  //                     ))}
  //                   </div>
  //                 </div>
  //                 <div className="App-card-divider" />
  //                 <div className="App-card-content">
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Link</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>About</Trans>
  //                     </div>
  //                     <div>{item.about}</div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Creator</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.creatorLink}>{item.creatorLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //         <div className="Tab-title-section">
  //           <div className="Page-title">
  //             <Trans>Dashboards</Trans>
  //           </div>
  //           <div className="Page-description">
  //             <Trans>OPEN dashboards and analytics.</Trans>
  //           </div>
  //         </div>
  //         <div className="DashboardV2-projects">
  //           {dashboardProjects.map((item) => {
  //             const linkLabel = item.linkLabel ? item.linkLabel : item.link;
  //             return (
  //               <div className="App-card" key={item.title}>
  //                 <div className="App-card-title">
  //                   {item.title}
  //                   <div className="App-card-title-icon">
  //                     {item.chainIds.map((network) => (
  //                       <img key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
  //                     ))}
  //                   </div>
  //                 </div>

  //                 <div className="App-card-divider"></div>
  //                 <div className="App-card-content">
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Link</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>About</Trans>
  //                     </div>
  //                     <div>{item.about}</div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Creator</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.creatorLink}>{item.creatorLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //         <div className="Tab-title-section">
  //           <div className="Page-title">
  //             <Trans>Partnerships and Integrations</Trans>
  //           </div>
  //           <div className="Page-description">
  //             <Trans>Projects integrated with OPEN.</Trans>
  //           </div>
  //         </div>
  //         <div className="DashboardV2-projects">
  //           {integrations.map((item) => {
  //             const linkLabel = item.linkLabel ? item.linkLabel : item.link;
  //             return (
  //               <div key={item.title} className="App-card">
  //                 <div className="App-card-title">
  //                   {item.title}
  //                   <div className="App-card-title-icon">
  //                     {item.chainIds.map((network) => (
  //                       <img key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
  //                     ))}
  //                   </div>
  //                 </div>
  //                 <div className="App-card-divider"></div>
  //                 <div className="App-card-content">
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Link</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>About</Trans>
  //                     </div>
  //                     <div>{item.about}</div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Announcement</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.announcementLink}>{item.announcementLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //         <div className="Tab-title-section">
  //           <div className="Page-title">
  //             <Trans>Telegram Groups</Trans>
  //           </div>
  //           <div className="Page-description">
  //             <Trans>Community-led Telegram groups.</Trans>
  //           </div>
  //         </div>
  //         <div className="DashboardV2-projects">
  //           {telegramGroups.map((item) => {
  //             const linkLabel = item.linkLabel ? item.linkLabel : item.link;
  //             return (
  //               <div className="App-card" key={item.title}>
  //                 <div className="App-card-title">{item.title}</div>
  //                 <div className="App-card-divider"></div>
  //                 <div className="App-card-content">
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>Link</Trans>
  //                     </div>
  //                     <div>
  //                       <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
  //                     </div>
  //                   </div>
  //                   <div className="App-card-row">
  //                     <div className="label">
  //                       <Trans>About</Trans>
  //                     </div>
  //                     <div>{item.about}</div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //       <Footer />
  //     </div>
  //   </SEO>
  // );
}
